<ng-container *transloco="let t">
  @if (dataSource() && columns().length) {
    <ui-table
      [dataSource]="dataSource()"
      [columns]="columns()"
      [columnTemplates]="columnTemplates()"
      [scrollConfig]="scrollConfig()"
      [pageSize]="pageSize()"
      [pageIndex]="pageIndex()"
      [showPagination]="showPagination()"
      [showPageSizeChanger]="showPageSizeChanger()"
      [total]="total()"
      [showTotal]="total() ? totalTemplate : null"
      [loading]="loading()"
      [frontPagination]="false"
      [isMultiSelect]="true"
      (onQueryParams)="onQueryParamsChange($event)"
      (onChecked)="handleChecked($event)"
    />
  }

  <ng-template #centerTemplate let-row="row">
    <ui-alarm-center-indicator
      [state]="row.dateEnd !== null ? 'active' : 'danger'"
      [name]="row.centerName"
      [centerId]="row.centerId"
      [distributorId]="row.distributorId"
      [rsabtId]="row.rsabtId"
      [tsabtId]="row.tsabtId"
      [vtnId]="row.vtnId"
      (onCenter)="emitCenter($event)"
    />
  </ng-template>
  <ng-template #lineTemplate let-row="row">
    @if (row.line_id) {
      <ui-alarm-center-indicator
        [state]="row.dateEnd !== null ? 'active' : 'danger'"
        [name]="row.line_name"
        [centerId]="row.centerId"
        [lineId]="row.line_id"
        [distributorId]="row.distributorId"
        [rsabtId]="row.rsabtId"
        [tsabtId]="row.tsabtId"
        [vtnId]="row.vtnId"
      />
    }
  </ng-template>
  <ng-template #categoryTemplate let-row="row">
    <ui-alarm-category-indicator
      [category]="row.alarmCategory"
      [type]="row.alarmType"
    />
  </ng-template>
  <ng-template #priorityTemplate let-row="row">
    <div class="mx-auto w-fit">
      <ui-priority-indicator [priority]="row.priority" />
    </div>
  </ng-template>
  <ng-template #phaseTemplate let-row="row">
    <div class="mx-auto w-fit">
      <ui-phase-indicator [phase]="getPhase(row.field.phase)" />
    </div>
  </ng-template>
  <ng-template #fieldTemplate let-row="row">
    <div class="ml-auto">
      <ui-badge-indicator
        [value]="row.field.value"
        [nominal]="row.field.reference_value"
        [percentage]="row.field.percentage"
        [units]="getUnit(row.field.unit)"
        [unitsReference]="getUnit(row.field.reference_value_unit)"
        [tooltipLabel]="'ALARMS.REF_VALUE'"
      />
    </div>
  </ng-template>
  <ng-template #startTemplate let-row="row">
    {{
      row.dateInit
        ? (row.dateInit
          | translocoDate: { dateStyle: 'short', timeStyle: 'short' })
        : '--'
    }}
  </ng-template>
  <ng-template #durationTemplate let-row="row">
    <ui-duration-indicator [dateInit]="row.dateInit" [dateEnd]="row.dateEnd" />
  </ng-template>
  <ng-template #actionsTemplate let-row="row">
    @if (hasWritePermission()) {
      <div class="flex justify-end">
        <ui-actions-indicator
          (onAction)="emitAction(row)"
          [actions]="{
            archive: {
              disabled: getActiveState(row.dateInit, row.dateEnd, row.read),
            },
          }"
        />
      </div>
    }
  </ng-template>
  <ng-template #totalTemplate>
    {{ total() | translocoDecimal }}
    {{ t('DISTRIBUTION_NETWORK.TABLE.RESULTS') }}
  </ng-template>
</ng-container>
